import { render, staticRenderFns } from "./WriteReviewItem.vue?vue&type=template&id=a163f1f0&"
import script from "./WriteReviewItem.vue?vue&type=script&lang=js&"
export * from "./WriteReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./WriteReviewItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports